import AbstractWidget, { lengthWithUnit } from './AbstractWidget';
import { removeClass } from '../utils/dom';
import { getTokenFor } from '../utils/arcgis';
// @ts-expect-error - data-catalog-js-api is not typed (yet)
import { ArcGISPortal } from 'data-catalog-js-api';
import { isNumericField } from './widgetDataUtils';

export default class LayerAttachmentsWidget extends AbstractWidget {
    render = (data: any, options: { [id: string]: any } = {}) => {
        if (
            this.container !== undefined &&
            this.container !== null &&
            this.design !== undefined &&
            this.design !== null
        ) {
            const doc = this.container.ownerDocument,
                topWidget = this.container.closest<HTMLElement>('.rb-report-widget'),
                dataAvailable = data !== undefined && data !== null && Array.isArray(data) && data.length > 0,
                { activeFeature, comparisonFeatures, idField, nameField, token } = options,
                settings = {
                    ...LayerAttachmentsWidget.getDefaults(),
                    ...this.design
                },
                {
                    showWhenEmpty = true,
                    imageSize = '128px,auto',
                    itemPadding = '5px 5px 5px 5px',
                    useTokensInUrls = true,
                    showImages = true,
                    hyperlinkImages = true,
                    filterText = '',
                    noRecordsFoundLabel = '',
                    itemsLayout = 'auto', // or 'grid'
                    itemsMaxGridCols = -1
                } = settings,
                imgSize = `width: ${imageSize.split(',')[0]}; height: ${
                    imageSize.split(',')[1] || imageSize.split(',')[0]
                };`,
                primaryAvailable =
                    activeFeature !== undefined &&
                    activeFeature !== null &&
                    idField !== undefined &&
                    idField !== null &&
                    data[0].indicators !== undefined &&
                    data[0].indicators !== null &&
                    data[0].indicators.length > 0;
            // Primary data source - get the source layer URL from that...
            if (showWhenEmpty || (dataAvailable && primaryAvailable)) {
                const primaryLayer = data.find((d: any) => d.primary === true),
                    primaryUrl =
                        primaryLayer !== undefined
                            ? primaryLayer.source !== undefined
                                ? primaryLayer.source.url
                                : primaryLayer.indicators[0].src
                            : '';
                if (primaryUrl === '') {
                    throw new Error(`Cannot access layer data source in dataset `);
                }
                ArcGISPortal.getInfo(primaryUrl, { token: getTokenFor(primaryUrl, token) })
                    .then((coreLayerInfo: any) => {
                        const oidf =
                                coreLayerInfo.objectIdField !== undefined ? coreLayerInfo.objectIdField : 'OBJECTID',
                            idf = coreLayerInfo.fields.find((f: any) => f.name.toLowerCase() === idField.toLowerCase()),
                            nmf = coreLayerInfo.fields.find(
                                (f: any) => f.name.toLowerCase() === nameField.toLowerCase()
                            ),
                            fParams = { token: token, outFields: `${oidf},${idf.name},${nmf.name}` };
                        ArcGISPortal.queryFeatures(
                            primaryUrl,
                            !isNumericField(idf)
                                ? `${idf.name} IN ('${(Array.isArray(activeFeature) ? activeFeature : [activeFeature])
                                      .map((f) => f.id)
                                      .join(`','`)}')`
                                : `${idf.name} IN (${(Array.isArray(activeFeature) ? activeFeature : [activeFeature])
                                      .map((f) => f.id)
                                      .join(`,`)})`,
                            1,
                            fParams
                        ).then((featureSet: any) => {
                            // TODO - deal with the use of multiple features
                            const objectIds = featureSet.map((f: any) => f[oidf]);
                            // Setup filters, because they could be feature-sensitive
                            const filters =
                                filterText === undefined || filterText === null || filterText.trim().length === 0
                                    ? []
                                    : filterText.split(',').map((t: string) => {
                                          const tt = t
                                              .replace(
                                                  /#FID|#FIDS/,
                                                  featureSet.map((f: any) => f[idf.name])
                                              )
                                              .replace(
                                                  /#FNAME|#FNAMES/,
                                                  featureSet.map((f: any) => f[nmf.name])
                                              );
                                          if (/^[0-9]+$/.test(t)) {
                                              return parseInt(t);
                                          } else if (tt.indexOf('regex:') === 0) {
                                              return new RegExp(tt.substring(6), 'i');
                                          } else {
                                              return new RegExp(tt.replaceAll('.', '\\.').replaceAll('*', '.*'), 'i');
                                          }
                                      });
                            const noAttachmentsLabel = noRecordsFoundLabel
                                .replace(
                                    /#FID|#FIDS/,
                                    featureSet.map((f: any) => f[idf.name])
                                )
                                .replace(
                                    /#FNAME|#FNAMES/,
                                    featureSet.map((f: any) => f[nmf.name])
                                );
                            ArcGISPortal.getFeatures(
                                `${primaryUrl}/queryAttachments`,
                                {
                                    objectIds: objectIds,
                                    f: 'json',
                                    token: getTokenFor(primaryUrl, token)
                                },
                                true
                            ).then((attachmentData: any) => {
                                if (attachmentData.attachmentGroups !== undefined) {
                                    let link, child, path, cell, grp;
                                    for (let srcFeature of featureSet) {
                                        const oid = srcFeature[oidf];
                                        grp = attachmentData.attachmentGroups.find(
                                            (g: any) => g.parentObjectId === oid
                                        );
                                        cell = doc.createElement(itemsLayout === 'list' ? 'ul' : 'div');
                                        cell.setAttribute('class', 'rb--generated rb-generated rb-attachments-content');
                                        if (grp !== undefined) {
                                            let attIdx = 1;
                                            for (let info of grp.attachmentInfos) {
                                                path = `${primaryUrl}/${grp.parentObjectId}/attachments/${info.id}`;
                                                let passesFilters = filters.length < 1 || filters.includes(attIdx);
                                                if (!passesFilters) {
                                                    for (const tester of filters) {
                                                        if (
                                                            typeof tester === 'object' &&
                                                            tester.constructor.name === 'RegExp'
                                                        ) {
                                                            passesFilters = passesFilters || tester.test(info.name);
                                                        }
                                                    }
                                                }
                                                if (passesFilters) {
                                                    if (useTokensInUrls && token !== undefined) {
                                                        path = `${path}?token=${getTokenFor(primaryUrl, token)}`;
                                                    }
                                                    link = cell.ownerDocument.createElement('a');
                                                    link.setAttribute('class', 'att-link');
                                                    link.setAttribute('target', '_blank');
                                                    link.setAttribute('rel', 'noreferrer');
                                                    link.setAttribute('type', info.contentType);
                                                    link.setAttribute('href', path);
                                                    if (showImages && info.contentType.indexOf('image/') === 0) {
                                                        child = cell.ownerDocument.createElement('img');
                                                        child.setAttribute('src', path);
                                                        child.setAttribute('alt', info.name);
                                                        // Grid and flex layout imposes its own size restrictions
                                                        if (itemsLayout === 'grid' || itemsLayout === 'centred') {
                                                            child.setAttribute('style', 'width: 100%;');
                                                        } else {
                                                            child.setAttribute('style', `${imgSize}`.trim());
                                                            if (itemPadding !== undefined) {
                                                                child.setAttribute(
                                                                    'style',
                                                                    `${imgSize}; padding: ${lengthWithUnit(
                                                                        itemPadding,
                                                                        'px',
                                                                        true,
                                                                        4
                                                                    )};`
                                                                );
                                                            }
                                                        }
                                                        if (info.keywords !== undefined && info.keywords !== '') {
                                                            child.setAttribute('title', info.keywords);
                                                        }
                                                        if (hyperlinkImages) {
                                                            link.appendChild(child);
                                                        } else {
                                                            link = child;
                                                        }
                                                    } else {
                                                        link.appendChild(cell.ownerDocument.createTextNode(info.name));
                                                    }
                                                    if (itemsLayout === 'centred') {
                                                        link.setAttribute(
                                                            'style',
                                                            `flex: 0 0 auto; line-height: 0; ${imgSize}`
                                                        );
                                                    }
                                                    if (itemsLayout === 'list') {
                                                        child = cell.ownerDocument.createElement('li');
                                                        child.appendChild(link);
                                                        cell.appendChild(child);
                                                    } else {
                                                        cell.appendChild(link);
                                                    }
                                                }
                                                attIdx++;
                                            }
                                        }
                                        if (cell.childNodes.length < 1) {
                                            link = cell.ownerDocument.createElement('div');
                                            link.setAttribute('class', 'att-empty');
                                            link.appendChild(cell.ownerDocument.createTextNode(noAttachmentsLabel));
                                            cell.appendChild(link);
                                        } else if (itemsLayout === 'grid') {
                                            let gridStyle = `display: grid; grid-template-columns: repeat(${
                                                itemsMaxGridCols > 0 ? itemsMaxGridCols : cell.children.length
                                            }, 1fr); grid-template-rows: 1fr;`;
                                            if (itemPadding !== undefined) {
                                                const parts = itemPadding.split(' ');
                                                gridStyle = `${gridStyle} gap: ${parts.slice(0, 2).join(' ')};`;
                                            }
                                            cell.setAttribute('style', gridStyle);
                                        } else if (itemsLayout === 'centred') {
                                            let flexStyle = `display: flex; flex-direction: row; flex-wrap: wrap; justify-content: center; align-items: center;`;
                                            if (itemPadding !== undefined) {
                                                const parts = itemPadding.split(' ');
                                                flexStyle = `${flexStyle} gap: ${parts.slice(0, 2).join(' ')};`;
                                            }
                                            cell.setAttribute('style', flexStyle);
                                        }
                                        this.container?.appendChild(cell);
                                    }
                                }
                            });
                        });
                    })
                    .catch((err: any) => {
                        this.renderError(err, settings.id, settings.scriptClass);
                    });
            }
            removeClass(topWidget, 'placeholder');
        }
    };

    static getDefaults = (): { [id: string]: any } => {
        return {
            ...AbstractWidget.getDefaults(),
            showImages: true,
            hyperlinkImages: true,
            imageSize: '128px,auto',
            itemPadding: '5px 5px 5px 5px',
            noRecordsFoundLabel: 'No attachments found',
            useTokensInUrls: true,
            filterText: '',
            itemsLayout: 'auto', // or 'grid' or 'list'
            itemsMaxGridCols: -1
        };
    };
}
